module.exports = __webpack_public_path__ + "static/media/blocker_specs.4db4235f.png";